import React, {Component} from 'react';
import Welcome from './welcome';

export default class Dashboard extends Component {
    render() {
        return (
            <div>
                <p>CMS DASHBOARD</p>
                <Welcome />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard/dashboard.js